import { createApiHook } from '../hooks';
import { searchApiFactory } from './searchApiFactory';

export const useSearchApi = createApiHook(searchApiFactory);
